import { render } from "./Footer.vue?vue&type=template&id=269085ae&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=269085ae&lang=less&scoped=true"

import exportComponent from "/Users/yuhu/qe-repo/qe-main-site/official-website-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-269085ae"]])

export default __exports__